"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canRaiseHand = void 0;
const isHoldingStick_1 = require("./isHoldingStick");
const hasRaisedHand_1 = require("./hasRaisedHand");
const isDiscussionHost_1 = require("./isDiscussionHost");
const SpeakingMode_1 = require("../types/SpeakingMode");
const hasStickBeenPassed_1 = require("./hasStickBeenPassed");
/**
 * Returns whether or not a discussion participant can raise their hand which adds them to the speaking queue.
 * Participants can only raise their hand during non-sequenced circles and if they're not already speaking or in the speaking queue.
 */
function canRaiseHand(discussion, participantId) {
    if (discussion.speakingMode !== SpeakingMode_1.SpeakingMode.NON_SEQUENCED) {
        return false;
    }
    return (!isDiscussionHost_1.isDiscussionHost(discussion, participantId) && // Host doesn't have a raise hand button
        (hasStickBeenPassed_1.hasStickBeenPassed(discussion) || !isHoldingStick_1.isHoldingStick(discussion, participantId)) && // Doesn't have the stick or has passed the stick
        !hasRaisedHand_1.hasRaisedHand(discussion, participantId) // Doesn't already have their hand up
    );
}
exports.canRaiseHand = canRaiseHand;
//# sourceMappingURL=canRaiseHand.js.map